module.exports = __webpack_public_path__ + "media/images/icon_home-c9f628976b026a1d7681139d600e4576.svg";